import Vue from 'vue'
import App from './App.vue'
//import App from './views/version/version.vue'
import router from './router'
import store from './store'
import LoginDialog from './components/loginDialog.vue';
import RegisterDialog from './components/RegisterDialog.vue';

import { Message } from 'element-ui'

import './assets/tailwind.css'
import 'font-awesome/css/font-awesome.min.css'



import flvjs from 'flv.js';

Vue.prototype.$message = Message;
import {
  Button,
  Avatar,
  Input,
  Table,
  TableColumn,
  TimeSelect,
  Timeline,
  TimelineItem,
  TimePicker,
  Dialog,
  Card,
  Container,
  Icon,
  Select,
  Form,
  Tag,
  Tree,
  Pagination,
  Badge,
  Loading,
  Menu,
  Tabs,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  Steps,
  Tooltip,
  Popover,
  Collapse,
  FormItem,
  Checkbox,
  CheckboxGroup,
  Header,
  DropdownMenu,
  DropdownItem,
  InputNumber,
  Aside,
  Main,
  MenuItem,
  MessageBox,
  Submenu,
  Option,
  Col,
  Row,
  Upload,
  Radio,
  DatePicker,
  RadioGroup,
  CollapseItem,
  Cascader,
  Switch,
  Image,
  Rate
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Switch);
Vue.use(Avatar);
Vue.use(flvjs);
Vue.use(CollapseItem);
Vue.use(Radio);
Vue.use(TimeSelect);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(TimePicker);
Vue.use(RadioGroup);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Row);
Vue.use(Col);
Vue.use(Option);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Header);
Vue.use(DropdownMenu);
Vue.use(DropdownItem); 
Vue.use(InputNumber);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(FormItem);
Vue.use(Collapse);
Vue.use(Popover);
Vue.use(Menu);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dropdown);
Vue.use(Steps);
Vue.use(Tooltip);
Vue.use(Tree);
Vue.use(Pagination);
Vue.use(Badge);
Vue.use(Loading);
Vue.use(Button);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Card);
Vue.use(Container);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Cascader);
Vue.use(Form);
Vue.use(Tag);
Vue.use(Image);
Vue.use(Rate);
Vue.config.productionTip = false
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm


import {postRequest} from "./utils/api";
import {postKeyValueRequest} from "./utils/api";
import {putRequest} from "./utils/api";
import {deleteRequest} from "./utils/api";
import {timestampToTime} from "./utils/api";
import {getRequest} from "./utils/api";
import {goLoginPage} from "./utils/api";
import {goRegisterPage} from "./utils/api";
import {goEditPwdPage} from "./utils/api";
import {saveLoginInfo} from "./utils/api";
import {getLoginInfo} from "./utils/api";
import {initMenu} from "./utils/menus";
import {getBase} from "./utils/api";
import {gethistorys} from "./utils/api";
import { parseTime } from "@/utils/date";


// 调用弹框
Vue.prototype.$loginDialog = LoginDialog
Vue.prototype.$registerDialog = RegisterDialog
Vue.prototype.getBase = getBase;
Vue.prototype.parseTime = parseTime;
Vue.prototype.gethistorys = gethistorys
Vue.prototype.postRequest = postRequest;
Vue.prototype.timestampToTime = timestampToTime;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.goLoginPage = goLoginPage;
Vue.prototype.goRegisterPage = goRegisterPage;
Vue.prototype.goEditPwdPage = goEditPwdPage;
Vue.prototype.saveLoginInfo = saveLoginInfo;
Vue.prototype.getLoginInfo = getLoginInfo;


Vue.config.productionTip = false


// 全局指令 - 点击外部关闭弹窗
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

/***router.beforeEach((to, from, next) => {
  if (to.path == '/') {
      next();
  } else {
      if (window.sessionStorage.getItem("token")) {
          initMenu(router, store);
          next();
      } else {
          next('/?redirect=' + to.path);
      }
  }
})
 */

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')